import {
  Box,
  Grid,
  Typography,
} from "@mui/material";

export const EmployeeDetailView = (props) => {
  //TODO: parse and set values from props object
  let person = props.details ? props.details : null;
  return (
    <Box>
      {/* Headers */}
      <Grid sx={{ marginTop: props.margin ? props.margin : "5px" }} container spacing={2}>
        <Grid key={0} item xs={1.2}>
          <Typography><b>Employee ID</b></Typography>
        </Grid>
        <Grid key={0} item xs={1.8}>
          <Typography><b>Name</b></Typography>
        </Grid>
        <Grid key={0} item xs={2}>
          <Typography><b>Division</b></Typography>
        </Grid>
        <Grid key={0} item xs={1}>
          <Typography><b>Location</b></Typography>
        </Grid>
        <Grid key={0} item xs={2.5}>
          <Typography><b>Work Schedule</b></Typography>
        </Grid>
        <Grid key={0} item xs={2.5}>
          <Typography><b>Schedule Area (Department)</b></Typography>
        </Grid>
        <Grid key={0} item xs={1}>
          <Typography><b>Work Area</b></Typography>
        </Grid>
        
        
      </Grid>
      {/* Values */}
      {person && <Grid container spacing={2}>
        <Grid key={0} item xs={1.2}>
          <Typography variant="body">{person.emplID}</Typography>
        </Grid>
        <Grid key={0} item xs={1.8}>
          <Typography variant="body" translate="no">{person.fullName}</Typography>
        </Grid>
        <Grid key={0} item xs={2}>
          <Typography variant="body">{person.mydiv}</Typography>
        </Grid>
        <Grid key={0} item xs={1}>
          <Typography variant="body">{person.mystore}</Typography>
        </Grid>
        <Grid key={0} item xs={2.5}>
          <Typography variant="body">{person.workschedule}</Typography>
        </Grid>
        <Grid key={0} item xs={2.5}>
          <Typography variant="body">{person.mydept}</Typography>
        </Grid>
        <Grid key={0} item xs={1}>
          <Typography variant="body">{person.workarea}</Typography>
        </Grid>
        
        
      </Grid>
      }
    </Box>
  );
};
